import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=3bc39234&scoped=true&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=3bc39234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc39234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\start-cms\\back-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc39234')) {
      api.createRecord('3bc39234', component.options)
    } else {
      api.reload('3bc39234', component.options)
    }
    module.hot.accept("./MenuItem.vue?vue&type=template&id=3bc39234&scoped=true&", function () {
      api.rerender('3bc39234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Navbar/MenuItem.vue"
export default component.exports